/* eslint-disable no-unused-vars */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-undef, new-cap */
// Komentar di atas memberi tahu linter untuk tidak komplain tentang variabel global L dan windyInit

import LandmarkSvc from '@/services/LandmarkSvc';
import SeriesSvc from '@/services/SeriesSvc';
import { convertDecimalToDMS } from '@/views/map/utils/coordinates';
import markerOnline from '@/assets/images/map/online-marker.svg';
import markerOffline from '@/assets/images/map/offline-marker.svg';
import headingOnline from '@/assets/images/map/online-heading.svg';
import headingOffline from '@/assets/images/map/offline-heading.svg';
import { getRpmTypeLabel } from '@/util/fms-summary';

// Helper function to convert minutes to HH:MM:SS format
function formatRunningMinutes(minutes) {
  // eslint-disable-next-line no-restricted-globals
  if (minutes === null || minutes === undefined || isNaN(minutes)) {
    return '-';
  }
  const totalSeconds = Math.floor(minutes * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

class MapService {
  constructor(vueComponent) {
    /**
     * @type {import('vue').default}
     * Referensi ke instance komponen Vue.
     * Dibutuhkan untuk mengakses props (ships), data, methods (handleClick), dan $store/$router.
     */
    this.vm = vueComponent;

    // Expose Vue instance to window for popup button click handler
    window.mapServiceVm = vueComponent;

    // State internal layanan
    this.map = null;
    this.shipsLayerGroups = {};
    this.trail = {};
    this.dotTrail = {};
    this.trailCheckboxStatus = {};
    this.currentPopupPage = 1;
    this.currentDotTrailPopupPage = 1;
    this.totalPopupPages = 3;
    this.landmarksVisible = false;
    this.landmarks = [];
    this.landmarksLayer = null;
    this.landmarkIcon = null;
    this.landmarkFetchTimeout = null;
    this.lastLandmarkBoundsKey = null;
    this.lastLandmarkBounds = null;
    this.clusterZoomThreshold = 8;
    this.baseLayers = {};
    this.activeBaseLayerKey = null;
    this.activeBaseLayer = null;
    this.mapSettingsPanel = null;
  }

  // --- Inisialisasi dan Penghancuran Peta ---

  initializeDefaultMap(elementId) {
    if (this.map || !document.getElementById(elementId)) return;

    const map = L.map(elementId).setView([-6.2, 106.816666], 13, {
      animate: true,
      pan: {
        duration: 1,
      },
    });
    map.setMinZoom(5);
    map.setMaxZoom(19);

    L.control.polylineMeasure(this.getPolylineMeasureOptions()).addTo(map);

    const googleLayer = L.tileLayer('https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&gl=id&hl=id', {
      maxZoom: 19,
      attribution: 'Map data © Google Maps',
    });
    const googleLayerSat = L.tileLayer('https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&gl=id&hl=id', {
      maxZoom: 19,
      attribution: 'Map data © Google Maps',
    });
    const osmLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap contributors',
    });

    this.map = map;
    this.baseLayers = {
      satellite: googleLayerSat,
      vectorColor: googleLayer,
      vectorWhite: osmLayer,
    };
    const storedKey = localStorage.getItem('activeBaseLayer') || 'satellite';
    this.setBaseLayer(this.baseLayers[storedKey] ? storedKey : 'satellite');

    // Menghubungkan event peta kembali ke komponen Vue
    map.on('polylinemeasure:start', () => this.vm.handlePolylineStart());
    map.on('polylinemeasure:change', (e) => this.vm.handlePolylineChange(e));
    map.on('polylinemeasure:clear', () => this.vm.handlePolylineClear());
    map.on('polylinemeasure:finish', () => this.vm.handlePolylineFinish());

    this.addMapSettingsControl();
    map.on('moveend', () => this.handleLandmarkViewportChange());
    map.on('zoomend', () => this.handleLandmarkViewportChange());
    this.addShipsToMap({ fitMapToBounds: true });
  }

  initializeWindyMap() {
    try {
      windyInit({
        key: 'R1CTVY4LQHEtYMnM4GPV8WAFq17eFPHg',
        lat: 0,
        lon: 0,
        zoom: 10,
      }, (windyAPI) => {
        this.map = windyAPI.map;
        const {
          picker, store, overlays, broadcast,
        } = windyAPI;

        // Logika event listener untuk tombol-tombol Windy
        document.getElementById('toggle-btn').addEventListener('click', () => {
          picker.close();
          document.getElementById('button-container').classList.toggle('hidden');
        });

        // Initialize numDirection
        store.set('numDirection', false);
        let numDirection = store.get('numDirection');
        document.getElementById('btn-num-direction').addEventListener('click', (button) => {
          picker.close();
          numDirection = !numDirection;
          store.set('numDirection', numDirection);
          button.target.innerText = `${numDirection ? 'on' : 'off'}`;
        });

        // Initialize graticule
        store.set('graticule', false);
        let graticule = store.get('graticule');
        document.getElementById('btn-graticule').addEventListener('click', (button) => {
          graticule = !graticule;
          store.set('graticule', graticule);
          button.target.innerText = `${graticule ? 'on' : 'off'}`;
        });

        // Initialize latlon
        store.set('latlon', true);
        let latlon = store.get('latlon');
        document.getElementById('btn-latlon').addEventListener('click', (button) => {
          picker.close();
          latlon = !latlon;
          store.set('latlon', latlon);
          button.target.innerText = `${latlon ? 'on' : 'off'}`;
        });

        // Initialize particlesAnim
        store.set('particlesAnim', 'on');
        const availableParticlesAnim = store.getAllowed('particlesAnim');
        let particlesAnim = store.get('particlesAnim');
        document.getElementById('btn-particles-anim').addEventListener('click', (button) => {
          const idx = availableParticlesAnim.indexOf(particlesAnim);
          particlesAnim = availableParticlesAnim[(idx + 1) % availableParticlesAnim.length];
          store.set('particlesAnim', particlesAnim);
          button.target.innerText = `${particlesAnim}`;
        });

        // Initialize isolines
        store.set('isolines', 'off');
        const availableIsolines = store.getAllowed('isolines');
        let isolines = store.get('isolines');
        document.getElementById('btn-isolines').addEventListener('click', (button) => {
          const idx = availableIsolines.indexOf(isolines);
          isolines = availableIsolines[(idx + 1) % availableIsolines.length];
          store.set('isolines', isolines);
          button.target.innerText = `${isolines}`;
        });

        let currentOverlay = 'wind';

        broadcast.on('redrawFinished', (params) => {
          currentOverlay = params.overlay;
          document.getElementById('btn-metric').innerText = `${overlays[currentOverlay].metric}`;
        });

        document.getElementById('btn-metric').addEventListener('click', (button) => {
          picker.close();
          overlays[currentOverlay].cycleMetric();
          button.target.innerText = `${overlays[currentOverlay].metric}`;
        });

        this.map = map;

        map.on('click', (e) => {
          const { lat, lng } = e.latlng;
          picker.open({ lat, lon: lng });
        });

        this.addShipsToMap({ fitMapToBounds: true });
      });
    } catch (error) {
      console.error('Error initializing Windy map:', error);
    }
  }

  destroy() {
    if (this.map) {
      this.map.off();
      this.map.remove();
    }
    this.map = null;
    this.shipsLayerGroups = {};
    this.trail = {};
    this.dotTrail = {};
    this.landmarks = [];
    this.landmarksLayer = null;
    this.landmarkIcon = null;
    this.lastLandmarkBoundsKey = null;
    this.lastLandmarkBounds = null;
    this.baseLayers = {};
    this.activeBaseLayerKey = null;
    this.activeBaseLayer = null;
    this.mapSettingsPanel = null;
    if (this.landmarkFetchTimeout) {
      clearTimeout(this.landmarkFetchTimeout);
      this.landmarkFetchTimeout = null;
    }
    // Clean up window reference
    window.mapServiceVm = null;
  }

  // --- Logika Penambahan Kapal dan Marker ---

  async addShipsToMap({ fitMapToBounds = true }) {
    if (!this.map) return;

    // Process all ships and collect trail promises
    const trailPromises = [];

    this.vm.ships.forEach((ship) => {
      const shipLayerGroup = L.layerGroup();
      this.shipsLayerGroups[ship.massId] = shipLayerGroup;

      const isSatMode = this.vm.mapMode === 'sat';

      // Create icons from iconConfig
      if (!ship.icon && ship.iconConfig) {
        ship.icon = L.icon({
          iconUrl: ship.iconConfig.iconUrl,
          iconSize: ship.iconConfig.iconSize,
          popupAnchor: [0, -41],
          tooltipAnchor: [-50, 50],
          className: 'ship-icon',
        });
      }

      if (!ship.markerIcon && ship.markerIconUrl) {
        ship.markerIcon = L.icon({
          iconUrl: ship.markerIconUrl,
          iconSize: [35, 61],
          className: 'marker-icon',
        });
      }

      // Create heading icon for non-default assets
      if (!ship.headingIcon && ship.iconConfig?.hasHeadingIcon) {
        // Use appropriate heading icon based on ship status
        let headingIconUrl = headingOffline;
        if (ship.shipStatus === 'online') {
          headingIconUrl = headingOnline;
        }

        ship.headingIcon = L.icon({
          iconUrl: headingIconUrl,
          iconSize: [120, 146],
          className: 'heading-icon',
        });
      }

      const headingMarker = this.createShipHeadingMarker(ship);
      const marker = this.createShipMarker(ship);

      // sat mode: Only show ship marker, no heading icon
      if (!isSatMode && ship.headingIcon) {
        shipLayerGroup.addLayer(headingMarker);
      }
      shipLayerGroup.addLayer(marker);

      if (ship.isVisible) {
        shipLayerGroup.addTo(this.map);
      }

      marker.bindPopup();

      marker.on('popupopen', (e) => {
        console.log('[addShipsToMap] popup open for ship:', ship.massId, ship);
        this.currentPopupPage = 1;
        this.updatePopupContent(e.popup, this.vm.ships.find((s) => s.massId === ship.massId));
      });

      const enableTrail = this.vm.Options?.enableTrail === 'true' || this.vm.Options?.enableTrail === true;
      this.trailCheckboxStatus[ship.massId] = enableTrail;
      if (enableTrail) {
        trailPromises.push(this.toggleTrail(true, ship));
      }
    });

    // Wait for all trails to be loaded
    await Promise.all(trailPromises);

    if (fitMapToBounds) this.fitMapToBounds();
  }

  async refreshShips() {
    console.log('[refreshShips] Refreshing ships...');
    if (!this.map) return;

    // Clear all existing ship layer groups
    Object.keys(this.shipsLayerGroups).forEach((massId) => {
      const layerGroup = this.shipsLayerGroups[massId];
      if (this.map.hasLayer(layerGroup)) {
        this.map.removeLayer(layerGroup);
      }
      layerGroup.clearLayers();
    });

    // Re-add all ships with updated data
    await this.addShipsToMap({ fitMapToBounds: false });
    console.log('[refreshShips] Ships refreshed.');
  }

  toggleShipVisibility(massId, isVisible) {
    const layerGroup = this.shipsLayerGroups[massId];
    if (!layerGroup) return;

    if (isVisible) {
      if (!this.map.hasLayer(layerGroup)) {
        this.map.addLayer(layerGroup);
      }
    } else if (this.map.hasLayer(layerGroup)) {
      this.map.removeLayer(layerGroup);
    }
  }

  showAllShips() {
    if (!this.map) return;
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const massId in this.shipsLayerGroups) {
      const layerGroup = this.shipsLayerGroups[massId];
      if (!this.map.hasLayer(layerGroup)) {
        this.map.addLayer(layerGroup);
      }
    }
  }

  hideAllShips() {
    if (!this.map) return;
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const massId in this.shipsLayerGroups) {
      const layerGroup = this.shipsLayerGroups[massId];
      if (this.map.hasLayer(layerGroup)) {
        this.map.removeLayer(layerGroup);
      }
    }
  }

  createShipMarker(ship) {
    const markerOptions = {
      icon: ship.icon,
      zIndexOffset: 2000, // Keep ship marker above trails and dot markers
    };

    // Add rotation for default assets (no heading icon)
    if (!ship.headingIcon) {
      const heading = ship.lastGpsData?.track || 0;
      markerOptions.rotationAngle = heading;
      markerOptions.rotationOrigin = '50% 50%';
    }

    const marker = L.marker(ship.lastLatLng, markerOptions);

    // sat mode: Always show as online
    const isSatMode = this.vm.mapMode === 'sat';
    // Use shipStatus property if available, otherwise fallback to old logic
    let tooltipClass;
    if (isSatMode) {
      tooltipClass = 'ship-online';
    } else if (ship.shipStatus) {
      // Map shipStatus to CSS class: online, offline, no-gps, no-sensor
      tooltipClass = `ship-${ship.shipStatus}`;
    } else {
      tooltipClass = ship.dataStatus && ship.lastGpsData ? 'ship-online' : 'ship-offline';
    }
    marker.bindTooltip(
      `<div class="ship-label ${tooltipClass}">${ship.massName}</div>`,
      { permanent: true, offset: [20, 10] },
    ).openTooltip();
    return marker;
  }

  createShipHeadingMarker(ship) {
    return L.marker(ship.lastLatLng, {
      icon: ship.headingIcon,
      rotationAngle: ship.lastGpsData.track || 0,
      rotationOrigin: '50% 50%',
      zIndexOffset: 2000, // Keep heading marker above trails
    });
  }

  fitMapToBounds() {
    if (!this.map || this.vm.ships.length === 0) return;

    const visibleShips = this.vm.ships.filter((ship) => ship.isVisible);
    if (visibleShips.length === 0) return;

    if (visibleShips.length === 1) {
      this.map.setView(visibleShips[0].lastLatLng, 9, {
        animate: true,
        pan: {
          duration: 1,
        },
      });
    } else {
      const group = new L.featureGroup(
        visibleShips.map((ship) => L.marker(ship.lastLatLng)),
      );
      this.map.fitBounds(group.getBounds(), { padding: [100, 100] });
    }
  }

  // --- Logika Trail ---

  async toggleTrail(isChecked, ship) {
    this.trailCheckboxStatus[ship.massId] = isChecked;

    if (isChecked) {
      const isSatMode = this.vm.mapMode === 'sat';

      // sat Mode: Fetch trail data from aggregated satellite GPS endpoint
      if (isSatMode && ship.massSateliteId) {
        await this.fetchAndRenderSatTrail(ship);
        return;
      }

      // Standard Mode: Use existing coordinates from ship data or fetch if not available
      const coordinates = ship.coordinates?.filter((x) => x[0] !== undefined && x[1] !== undefined) || [];

      // If no coordinates available, fetch summary data first
      if (coordinates.length === 0) {
        console.log('[toggleTrail] No coordinates available, fetching summary data...');
        try {
          await this.vm.handleFetchAllLastSummary('standard');
          // Refresh ship reference to get updated data
          const updatedShip = this.vm.ships.find((s) => s.massId === ship.massId);
          if (updatedShip) {
            ship = updatedShip;
          }
        } catch (error) {
          console.error('[toggleTrail] Error fetching summary data:', error);
          return;
        }
      }

      const finalCoordinates = ship.coordinates?.filter((x) => x[0] !== undefined && x[1] !== undefined) || [];

      if (finalCoordinates.length === 0) {
        console.warn('[toggleTrail] No coordinates available after fetching data');
        return;
      }

      // Create trail polyline with low zIndex to keep it below markers
      // Use shipStatus to determine trail color
      let trailColor;
      switch (ship.shipStatus) {
        case 'online':
          trailColor = '#28F385'; // Green
          break;
        case 'no-sensor':
          trailColor = '#F97316'; // Orange
          break;
        case 'no-gps':
          trailColor = '#9CA3AF'; // Gray
          break;
        default:
          trailColor = '#FF3B30'; // Red (offline)
      }
      const trailLayer = L.polyline(finalCoordinates, {
        color: trailColor,
        weight: 4,
        zIndexOffset: -1000, // Keep trail below all markers
      });
      this.shipsLayerGroups[ship.massId].addLayer(trailLayer);
      this.trail[ship.massId] = trailLayer;
      this.map.fitBounds(trailLayer.getBounds());
      this.toggleDotTrail(true, ship);
    } else if (this.trail[ship.massId]) {
      this.shipsLayerGroups[ship.massId].removeLayer(this.trail[ship.massId]);
      delete this.trail[ship.massId];
      this.toggleDotTrail(false, ship);
    }
  }

  async fetchAndRenderSatTrail(ship) {
    try {
      // Calculate time range (last 24 hours)
      const lastTimestamp = ship.lastGpsData?.timestamp || Math.floor(Date.now() / 1000);
      const startTimestamp = Math.floor(lastTimestamp / 3600) * 3600 - 86400; // 24 hours ago
      const endTimestamp = Math.floor(Date.now() / 1000);

      console.log('[fetchAndRenderSatTrail] Fetching GPS + RPM trail data for ship:', ship.massSateliteId);
      console.log('[fetchAndRenderSatTrail] Time range:', {
        startTimestamp,
        endTimestamp,
        startDate: new Date(startTimestamp * 1000).toISOString(),
        endDate: new Date(endTimestamp * 1000).toISOString(),
      });

      // Fetch GPS, RPM, and AE data in parallel
      console.log('[fetchAndRenderSatTrail] Fetching GPS, RPM, and AE data in parallel...');
      const [gpsResponse, rpmResponse, aeResponse] = await Promise.all([
        SeriesSvc.getAggregatedSatelliteGpsByPeriod(startTimestamp, endTimestamp, {
          params: {
            device: [ship.massSateliteId],
          },
        }),
        SeriesSvc.getAggregatedSatelliteRpmByPeriod(startTimestamp, endTimestamp, {
          params: {
            device: [ship.massSateliteId],
          },
        }),
        SeriesSvc.getAggregatedSatelliteAeByPeriod(startTimestamp, endTimestamp, {
          params: {
            device: [ship.massSateliteId],
          },
        }),
      ]);

      console.log('[fetchAndRenderSatTrail] GPS response series:', gpsResponse?.data?.data?.series);
      console.log('[fetchAndRenderSatTrail] RPM response series:', rpmResponse?.data?.data?.series);
      console.log('[fetchAndRenderSatTrail] AE response series:', aeResponse?.data?.data?.series);

      const gpsSeries = gpsResponse?.data?.data?.series || [];
      const rpmSeries = rpmResponse?.data?.data?.series || [];
      const aeSeries = aeResponse?.data?.data?.series || [];

      if (gpsSeries.length === 0) {
        console.warn('[fetchAndRenderSatTrail] No GPS trail data found for:', ship.massSateliteId);
        return;
      }

      console.log('[fetchAndRenderSatTrail] GPS data points:', gpsSeries.length);
      console.log('[fetchAndRenderSatTrail] RPM data points:', rpmSeries.length);
      console.log('[fetchAndRenderSatTrail] AE data points:', aeSeries.length);

      // Group RPM data by hour for matching
      const rpmByHour = new Map();
      rpmSeries.forEach((rpmData) => {
        const hour = Math.floor(rpmData.timestamp / 3600);
        if (!rpmByHour.has(hour)) {
          rpmByHour.set(hour, []);
        }
        rpmByHour.get(hour).push(rpmData);
      });

      // Group AE data by hour for matching
      const aeByHour = new Map();
      aeSeries.forEach((aeData) => {
        const hour = Math.floor(aeData.timestamp / 3600);
        if (!aeByHour.has(hour)) {
          aeByHour.set(hour, []);
        }
        aeByHour.get(hour).push(aeData);
      });

      console.log('[fetchAndRenderSatTrail] RPM grouped by hour:', Object.fromEntries(rpmByHour));
      console.log('[fetchAndRenderSatTrail] AE grouped by hour:', Object.fromEntries(aeByHour));

      // Merge GPS, RPM, and AE data by matching hour (ignore minutes)
      const mergedSeries = gpsSeries.map((gpsPoint) => {
        const gpsHour = Math.floor(gpsPoint.timestamp / 3600);
        const matchingRpmData = rpmByHour.get(gpsHour) || [];
        const matchingAeData = aeByHour.get(gpsHour) || [];

        // Find RPM data for all types (PORT, STARBOARD, CENTER)
        const portRpm = matchingRpmData.find((r) => r.type === 'PORT');
        const starboardRpm = matchingRpmData.find((r) => r.type === 'STARBOARD');
        const centerRpm = matchingRpmData.find((r) => r.type === 'CENTER');

        // Find AE data for this hour (get the one with highest no or status = 1)
        const activeAe = matchingAeData.find((ae) => ae.status === 1) || matchingAeData[0];

        return {
          ...gpsPoint,
          portRpm: portRpm?.rpm || null,
          starboardRpm: starboardRpm?.rpm || null,
          centerRpm: centerRpm?.rpm || null,
          portRunningMinutes: portRpm?.runningMinutes || null,
          starboardRunningMinutes: starboardRpm?.runningMinutes || null,
          centerRunningMinutes: centerRpm?.runningMinutes || null,
          currentAe: activeAe?.no || null,
          aeRunningMinutes: activeAe?.runningMinutes || null,
          aeStatus: activeAe?.status || null,
        };
      });

      console.log('[fetchAndRenderSatTrail] Merged series (first 5 points):', mergedSeries.slice(0, 5));
      console.log('[fetchAndRenderSatTrail] Merged series structure keys:', mergedSeries[0] ? Object.keys(mergedSeries[0]) : 'N/A');

      // Extract coordinates from merged series
      const coordinates = mergedSeries.map((point) => [point.latitude, point.longitude]);

      // Create trail polyline with low zIndex and green color for sat
      const trailLayer = L.polyline(coordinates, {
        color: '#28F385', // Green for sat mode
        weight: 4,
        zIndexOffset: -1000, // Keep trail below all markers
      });
      this.shipsLayerGroups[ship.massId].addLayer(trailLayer);
      this.trail[ship.massId] = trailLayer;
      this.map.fitBounds(trailLayer.getBounds());

      // Create dot trail markers with popup data
      this.dotTrail[ship.massId] = [];
      const SatMarkerIcon = L.icon({
        iconUrl: markerOnline,
        iconSize: [35, 61],
        className: 'marker-icon',
      });

      // Skip the last (most recent) data point
      const seriesToRender = mergedSeries.slice(0, -1);
      seriesToRender.forEach((data) => {
        const marker = L.marker([data.latitude, data.longitude], {
          icon: SatMarkerIcon, // Always use online icon for sat dot trail
          zIndexOffset: 1000, // Keep markers above trails
        });
        marker.bindPopup(() => this.createSatDotTrailPopupContent(ship, data));
        marker.on('popupopen', (e) => {
          this.currentDotTrailPopupPage = 1;
          e.target.setPopupContent(this.createSatDotTrailPopupContent(ship, data));
        });
        this.dotTrail[ship.massId].push(marker);
        this.shipsLayerGroups[ship.massId].addLayer(marker);
      });

      console.log('[fetchAndRenderSatTrail] Trail rendered for:', ship.massSateliteId, 'points:', seriesToRender.length, '(skipped most recent point)');
    } catch (error) {
      console.error('[fetchAndRenderSatTrail] Error fetching trail data:', error);
    }
  }

  createSatDotTrailPopupContent(ship, data) {
    const timestamp = data?.timestamp;
    const datetime = timestamp ? new Date(timestamp * 1000).toLocaleString() : '-';
    const latitude = data?.latitude;
    const longitude = data?.longitude;
    const portRpm = data?.portRpm;
    const starboardRpm = data?.starboardRpm;
    const currentAe = data?.currentAe;

    const latDMS = latitude ? convertDecimalToDMS(latitude, true) : '-';
    const lngDMS = longitude ? convertDecimalToDMS(longitude, false) : '-';
    const coordinateDisplay = `${latDMS}, ${lngDMS}`;

    return /* html */`
      <div class="row pt-3">
        <div class="col-6 d-flex align-items-center"><h6>${ship.massName || '-'}</h6></div>
        <div class="col-6 d-flex justify-content-end align-items-center pt-0"><span class="status online">online</span></div>
      </div>
      <hr style="margin: 12px 0;" />
      <div class="row"><div class="col-12"><p style="margin: 0; font-size: 13px"><b>Time: </b> ${datetime}</p></div></div>
      <hr style="margin: 12px 0;" />
      <div class="row info-section pb-2" style="margin-bottom: 8px;">
        <div class="col-12" style="height: 60px;"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Coordinates</p><p style="font-weight: 1000; color: #1e1e1e; font-size: 13px">${coordinateDisplay}</p></div>
      </div>
      <div class="row info-section pb-2" style="margin-bottom: 8px;">
        <div class="col-6" style="height: 60px;"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Port RPM</p><p style="font-weight: 1000; color: #1e1e1e">${portRpm !== null ? portRpm : '-'}</p></div>
        <div class="col-6" style="height: 60px;"><p style="margin-top: 0; margin-bottom: -10px">Starboard RPM</p><p style="font-weight: 1000; color: #1e1e1e">${starboardRpm !== null ? starboardRpm : '-'}</p></div>
      </div>
      ${currentAe !== null ? `
      <div class="row info-section pb-2" style="margin-bottom: 8px;">
        <div class="col-12" style="height: 60px;"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Active AE</p><p style="font-weight: 1000; color: #1e1e1e">AE ${currentAe}</p></div>
      </div>
      ` : ''}
    `;
  }

  toggleDotTrail(isChecked, ship) {
    if (isChecked) {
      const isSatMode = this.vm.mapMode === 'sat';
      const coordinatesData = ship.coordinatesData.filter((x) => x.latLong[0] !== undefined && x.latLong[1] !== undefined);
      this.dotTrail[ship.massId] = this.dotTrail[ship.massId] || [];

      // sat mode: Always use online marker icon
      const markerIcon = isSatMode ? markerOnline : ship.markerIcon;

      coordinatesData.forEach((data) => {
        const marker = L.marker(data.latLong, {
          icon: markerIcon,
          rotationAngle: data.heading || 0,
          rotationOrigin: '50% 50%',
          zIndexOffset: 1000, // Keep dot markers above trails but below ship marker
        });
        marker.bindPopup(() => this.createDotTrailPopupContent(ship, data));
        marker.on('popupopen', (e) => {
          this.currentDotTrailPopupPage = 1;
          e.target.setPopupContent(this.createDotTrailPopupContent(ship, data));
          this.setupDotTrailPaginationButtons(e.target, ship, data);
        });
        this.dotTrail[ship.massId].push(marker);
        this.shipsLayerGroups[ship.massId].addLayer(marker);
      });
    } else if (this.dotTrail[ship.massId]) {
      this.dotTrail[ship.massId].forEach((marker) => {
        this.shipsLayerGroups[ship.massId].removeLayer(marker);
      });
      delete this.dotTrail[ship.massId];
    }
  }

  // --- Logika Popup ---

  updatePopupContent(popup, ship) {
    console.log('[updatePopupContent] updating popup content for ship:', ship.massId);
    const newPopupContent = this.createPopupContent(ship);
    popup.setContent(newPopupContent);
    this.addEventListener(popup, ship); // Re-attach listeners
  }

  addEventListener(popup, ship) {
    this.setupButtonEvent(`report-${ship.massId}`, () => this.vm.handleClickReport(ship.massId));
    this.setupButtonEvent(`dashboard-${ship.massId}`, () => this.vm.handleClickDashboard(ship.massId));
    this.setupButtonEvent(`voyage-${ship.massId}`, () => this.vm.handleClickVoyage(ship.massId));

    this.setupButtonEvent(`previous-popup-button-${ship.massId}`, () => {
      if (this.currentPopupPage > 1) {
        this.currentPopupPage--;
        this.updatePopupContent(popup, ship);
      }
    });
    this.setupButtonEvent(`next-popup-button-${ship.massId}`, () => {
      if (this.currentPopupPage < this.totalPopupPages) {
        this.currentPopupPage++;
        this.updatePopupContent(popup, ship);
      }
    });

    const trailSwitch = document.getElementById(`trail-switch-${ship.massId}`);
    if (trailSwitch) {
      trailSwitch.onchange = async (event) => {
        const isChecked = event.target.checked;
        if (isChecked) {
          // Pass the current map mode to fetch data from correct endpoint
          const mode = this.vm.mapMode || 'standard';
          await this.vm.handleGetLastData(mode);
        }
        await this.toggleTrail(isChecked, ship);
        this.updatePopupContent(popup, ship);
      };
    }

    const dotTrailSwitch = document.getElementById(`dot-trail-switch-${ship.massId}`);
    if (dotTrailSwitch) {
      dotTrailSwitch.onchange = (event) => {
        this.toggleDotTrail(event.target.checked, ship);
      };
    }
  }

  setupButtonEvent(buttonId, callback) {
    setTimeout(() => {
      const button = document.getElementById(buttonId);
      if (button) {
        button.onclick = callback;
      }
    }, 0);
  }

  createPopupContent(ship) {
    console.log('[createPopupContent] creating popup content for ship:', ship.massId);
    const isSatMode = this.vm.mapMode === 'sat';

    if (isSatMode) {
      // sat mode: Only show GPS data
      return this.createSatPopupContent(ship);
    }

    // Standard mode: Show full data with pagination
    let infoHTML;
    switch (this.currentPopupPage) {
      case 1: infoHTML = this.renderFirstPageInfo(ship); break;
      case 2: infoHTML = this.renderSecondPageInfo(ship); break;
      case 3: infoHTML = this.renderThirdPageInfo(ship); break;
      default: infoHTML = this.renderFirstPageInfo(ship); break;
    }
    return /* html */`
      <div class="row pt-3">
        <div class="col-6 d-flex align-items-center"><h5>${ship.massName || '-'}</h5></div>
        <div class="col-6 d-flex justify-content-end align-items-center pt-0"><h5 class="status online">online</h5></div>
      </div>
      <hr style="margin: 12px 0;" />
      <div class="row"><div class="col-12"><p style="margin: 0; font-size: 14px"><b>Last Data: </b> ${new Date(ship.lastGpsData?.timestamp * 1000 || 0).toLocaleString()}</p></div></div>
      <hr style="margin: 12px 0;" />
      <div class="row info-section pb-2">${infoHTML}</div>
      <hr style="margin: 12px 0;" />
      <div class="row pb-3">${this.renderTrailSwitches(ship)}</div>
      <hr style="margin: 12px 0;" />
      <div class="row button-section">${this.renderActionButtons(ship)}</div>
    `;
  }

  createSatPopupContent(ship) {
    console.log('[createSatPopupContent] creating sat popup content for ship:', ship.massId);
    const gpsData = ship.lastGpsData;
    const latitude = gpsData?.latitude ?? gpsData?.lat;
    const longitude = gpsData?.longitude ?? gpsData?.lng;
    const timestamp = gpsData?.timestamp;
    const datetime = timestamp ? new Date(timestamp * 1000).toLocaleString() : '-';

    // Convert decimal coordinates to DMS
    const latDMS = latitude ? convertDecimalToDMS(latitude, true) : '-';
    const lngDMS = longitude ? convertDecimalToDMS(longitude, false) : '-';
    const coordinateDisplay = latitude && longitude ? `${latDMS}, ${lngDMS}` : '-';

    // Get RPM data - extract unique types from lastRpmData
    const rpmTypes = [...new Set((ship.lastRpmData || []).map((rpm) => rpm.type))];
    const displayLabels = rpmTypes.map((type) => getRpmTypeLabel(type, rpmTypes));

    // Build RPM HTML dynamically based on available types
    let rpmHtml = '';
    rpmTypes.forEach((type, index) => {
      const rpmData = ship.lastRpmData?.find((rpm) => rpm.type === type);
      const rpmValue = Math.floor(rpmData?.rpm || 0);
      const displayLabel = displayLabels[index];
      rpmHtml += `
        <div class="col-6" style="height: 60px;">
          <p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">${displayLabel} RPM</p>
          <p style="font-weight: 1000; color: #1e1e1e">${rpmValue}</p>
        </div>
      `;
    });

    // Get AE data
    const activeAe = ship.lastAeData?.find((ae) => ae.status === 1) || ship.lastAeData?.[0];
    const currentAe = activeAe?.no;

    // sat mode: Always show as online
    return /* html */`
      <div class="row pt-3">
        <div class="col-6 d-flex align-items-center"><h5>${ship.massName || '-'}</h5></div>
        <div class="col-6 d-flex justify-content-end align-items-center pt-0"><h5 class="status online">online</h5></div>
      </div>
      <hr style="margin: 12px 0;" />
      <div class="row"><div class="col-12"><p style="margin: 0; font-size: 14px"><b>Last Data: </b> ${datetime}</p></div></div>
      <hr style="margin: 12px 0;" />
      <div class="row info-section pb-2" style="">
        <div class="col-12" style="height: 60px;"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Coordinates</p><p style="font-weight: 1000; color: #1e1e1e">${coordinateDisplay}</p></div>
      </div>
      ${rpmHtml ? `<div class="row info-section pb-2" style="">${rpmHtml}</div>` : ''}
      ${currentAe !== null && currentAe !== undefined ? `
      <div class="row info-section pb-2" style="">
        <div class="col-12" style="height: 60px;"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Active AE</p><p style="font-weight: 1000; color: #1e1e1e">AE ${currentAe}</p></div>
      </div>
      ` : ''}
      <hr style="margin: 12px 0;" />
      <div class="row pb-3">${this.renderTrailSwitches(ship, true)}</div>
    `;
  }

  renderFirstPageInfo(ship) {
    console.log('[renderFirstPageInfo] rendering first page info for ship:', ship.massId);
    console.log('[renderFirstPageInfo] ship:', ship);
    const landmarkName = ship?.nearestLandmark?.name;
    const distanceMeters = ship?.nearestLandmark?.distanceMeters;
    const distanceNm = typeof distanceMeters === 'number' ? (distanceMeters / 1852).toFixed(2) : null;
    const landmarkInfo = landmarkName && distanceNm ? `${landmarkName} (${distanceNm} NM)` : null;

    // Get RPM data - extract unique types from lastRpmData
    const rpmTypes = [...new Set((ship.lastRpmData || []).map((rpm) => rpm.type))];
    const displayLabels = rpmTypes.map((type) => getRpmTypeLabel(type, rpmTypes));

    // Build RPM HTML dynamically based on available types
    let rpmHtml = '';
    rpmTypes.forEach((type, index) => {
      const rpmData = ship.lastRpmData?.find((rpm) => rpm.type === type);
      const rpmValue = Math.floor(rpmData?.rpm || 0);
      const displayLabel = displayLabels[index];
      rpmHtml += `
        <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">${displayLabel} RPM</p><p style="font-weight: 1000; color: #1e1e1e">${rpmValue}</p></div>
      `;
    });

    return /* html */`
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">${landmarkInfo ? 'Nearest Landmark' : 'Coordinates'}</p><p style="font-weight: 1000; color: #1e1e1e">${landmarkInfo || ship?.lastCoordinate || '-'}</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px">Current Speed</p><p style="font-weight: 1000; color: #1e1e1e">${ship?.lastGpsData?.speed ? (ship?.lastGpsData?.speed / 1.852).toFixed(2) : '-'} knot</p></div>
      ${rpmHtml}
      `;
  }

  renderSecondPageInfo(ship) {
    console.log('[renderSecondPageInfo] rendering second page info for ship:', ship.massId);
    return /* html */`
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px">Total Cruise</p><p style="font-weight: 1000; color: #1e1e1e">${ship.summary?.gps?.summary?.totalDistance ? (ship.summary.gps.summary.totalDistance / 1852).toFixed(2) : '-'} NM</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px">Current AE</p><p style="font-weight: 1000; color: #1e1e1e">AE ${ship.lastAeData?.find((ae) => ae.rpm > 0)?.no + 1 || '-'}</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px">Port In Flowrate</p><p style="font-weight: 1000; color: #1e1e1e">${Math.floor(ship.lastFmData?.find((fm) => fm.deviceId.split('-').pop() === '1')?.volumeFlowrate || 0)} L/h</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px">Starboard In Flowrate</p><p style="font-weight: 1000; color: #1e1e1e">${Math.floor(ship.lastFmData?.find((fm) => fm.deviceId.split('-').pop() === '3')?.volumeFlowrate || 0)} L/h</p></div>
    `;
  }

  renderThirdPageInfo(ship) {
    console.log('[renderThirdPageInfo] rendering third page info for ship:', ship.massId);

    const portExhaustTemperature = ship.lastTemperatureData?.find((temperature) => temperature.type === 'PORT' && temperature.device.devcLabel === 'EXHAUST_TEMPERATURE')?.temperature;
    const stbdExhaustTemperature = ship.lastTemperatureData?.find((temperature) => temperature.type === 'STARBOARD' && temperature.device.devcLabel === 'EXHAUST_TEMPERATURE')?.temperature;

    const portReservoirTemperature = ship.lastTemperatureData?.find((temperature) => temperature.type === 'PORT' && temperature.device.devcLabel === 'TEMPERATURE')?.temperature;
    const stbdReservoirTemperature = ship.lastTemperatureData?.find((temperature) => temperature.type === 'STARBOARD' && temperature.device.devcLabel === 'TEMPERATURE')?.temperature;

    return /* html */`
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Port Exhaust Temp.</p><p style="font-weight: 1000; color: #1e1e1e">${Math.floor(portExhaustTemperature || 0)} °C</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px">Stbd Exhaust Temp.</p><p style="font-weight: 1000; color: #1e1e1e">${Math.floor(stbdExhaustTemperature || 0)} °C</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px">Port Reservoir Temp.</p><p style="font-weight: 1000; color: #1e1e1e">${Math.floor(portReservoirTemperature || 0)} °C</p></div>
      <div class="col-6" style="height: 60px"><p style="margin-top: 0; margin-bottom: -10px">Stbd Reservoir Temp.</p><p style="font-weight: 1000; color: #1e1e1e">${Math.floor(stbdReservoirTemperature || 0)} °C</p></div>
    `;
  }

  renderTrailSwitches(ship, isSatMode = false) {
    const isChecked = this.trailCheckboxStatus[ship.massId];
    const hasDotTrail = this.dotTrail[ship.massId] && this.dotTrail[ship.massId].length > 0;

    // sat mode: No pagination buttons (only 1 page)
    if (isSatMode) {
      return /* html */`
        <div class="col-12 d-flex justify-content-between align-items-center">
          <div>
            <div class="custom-control custom-switch mr-2">
              <input type="checkbox" class="custom-control-input" id="trail-switch-${ship.massId}" ${isChecked ? 'checked' : ''} />
              <label class="custom-control-label" for="trail-switch-${ship.massId}">Vessel Trail</label>
            </div>
            ${isChecked ? `
            <div class="custom-control custom-switch mr-2">
              <input type="checkbox" class="custom-control-input" id="dot-trail-switch-${ship.massId}" ${hasDotTrail ? 'checked' : ''} />
              <label class="custom-control-label" for="dot-trail-switch-${ship.massId}">Dot Trail</label>
            </div>` : ''}
          </div>
          <button class="btn btn-sm btn-mantraz" style="display: flex; align-items: center; justify-content: center;" onclick="window.mapServiceVm.viewSatelliteDatalog('${ship.massId}')">
            <i class="fas fa-file-alt mr-2"></i>View Log
          </button>
        </div>
      `;
    }

    // Standard mode: With pagination buttons
    return /* html */`
      <div class="col-6" style="height: 15px">
        <div class="custom-control custom-switch mr-2">
          <input type="checkbox" class="custom-control-input" id="trail-switch-${ship.massId}" ${isChecked ? 'checked' : ''} />
          <label class="custom-control-label" for="trail-switch-${ship.massId}">Vessel Trail</label>
        </div>
        ${isChecked ? `
        <div class="custom-control custom-switch mr-2">
          <input type="checkbox" class="custom-control-input" id="dot-trail-switch-${ship.massId}" ${hasDotTrail ? 'checked' : ''} />
          <label class="custom-control-label" for="dot-trail-switch-${ship.massId}">Dot Trail</label>
        </div>` : ''}
      </div>
      <div class="col-6 d-flex justify-content-end">
        <button class="btn btn-sm btn-outline-mantraz mr-1" id="previous-popup-button-${ship.massId}" ${this.currentPopupPage === 1 ? 'disabled' : ''}>Previous</button>
        <button class="btn btn-sm btn-outline-mantraz" id="next-popup-button-${ship.massId}" ${this.currentPopupPage === this.totalPopupPages ? 'disabled' : ''}>Next</button>
      </div>
    `;
  }

  renderActionButtons(ship) {
    let content = /* html */`
        <div class="col-6 my-1"><button class="btn btn-sm btn-block btn-mantraz tooltip-button" id="report-${ship.massId}">View Report</button></div>
        <div class="col-6 my-1"><button class="btn btn-sm btn-block btn-outline-mantraz tooltip-button" id="dashboard-${ship.massId}">View Dashboard</button></div>
      `;
    if (this.vm.Options?.hideVoyageButton !== true && this.vm.Options?.hideVoyageButton !== 'true') {
      content += `<div class="col-12 my-1"><button class="btn btn-sm btn-block btn-mantraz tooltip-button" id="voyage-${ship.massId}">Voyage Report</button></div>`;
    }
    return content;
  }

  // --- Dot Trail Popup ---

  createDotTrailPopupContent(ship, data) {
    console.log('[createDotTrailPopupContent] Creating popup content for:', ship.massId);
    console.log('[createDotTrailPopupContent] Popup data:', data);
    console.log('[createDotTrailPopupContent] data.centerRpm:', data?.centerRpm);
    console.log('[createDotTrailPopupContent] data.portRpm:', data?.portRpm);
    console.log('[createDotTrailPopupContent] data.starboardRpm:', data?.starboardRpm);

    const location = '-';
    const totalCruise = data?.totalCruise ? (data?.totalCruise / 1852).toFixed(2) : '-';
    const avgSpeed = data?.avgSpeed ? (data?.avgSpeed * 0.5399568034557236).toFixed(2) : '-';
    const currentAE = data?.currentAe || '-';

    // Get RPM data - extract unique types from merged series data
    const rpmTypes = [];
    console.log('[createDotTrailPopupContent] Checking RPM data availability:');
    if (data?.portRpm !== null && data?.portRpm !== undefined) {
      rpmTypes.push('PORT');
      console.log('[createDotTrailPopupContent] PORT RPM found:', data.portRpm);
    }
    if (data?.starboardRpm !== null && data?.starboardRpm !== undefined) {
      rpmTypes.push('STARBOARD');
      console.log('[createDotTrailPopupContent] STARBOARD RPM found:', data.starboardRpm);
    }
    if (data?.centerRpm !== null && data?.centerRpm !== undefined) {
      rpmTypes.push('CENTER');
      console.log('[createDotTrailPopupContent] CENTER RPM found:', data.centerRpm);
    }
    console.log('[createDotTrailPopupContent] rpmTypes array:', rpmTypes);

    const displayLabels = rpmTypes.map((type) => getRpmTypeLabel(type, rpmTypes));
    console.log('[createDotTrailPopupContent] displayLabels:', displayLabels);

    // Get RPM values with display labels
    const rpmValues = rpmTypes.map((type) => {
      const rpmKey = `${type.toLowerCase()}Rpm`;
      console.log('[createDotTrailPopupContent] Getting RPM value for key:', rpmKey, 'from data:', data?.[rpmKey]);
      return {
        type,
        displayLabel: displayLabels[rpmTypes.indexOf(type)],
        value: data?.[rpmKey]?.toFixed(2) || '-',
      };
    });
    console.log('[createDotTrailPopupContent] rpmValues:', rpmValues);

    let content = `
          <hr /><div class="row"><div class="col-12"><p style="margin: 0; font-size: 14px"><b>Datetime: </b> ${new Date(data.gpsData.timestamp * 1000 || 0).toLocaleString()}</p></div></div><hr />
          <div class="row info-section pb-2">`;

    if (this.currentDotTrailPopupPage === 1) {
      content += /* html */ `
        <div class="col-6" style="height: 50px">
          <p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">Location</p>
          <p style="font-weight: 1000; color: #1e1e1e">${location}</p>
        </div>
        <div class="col-6" style="height: 50px">
          <p style="margin-top: 0; margin-bottom: -10px">Total Cruise</p>
          <p style="font-weight: 1000; color: #1e1e1e">${totalCruise} NM</p>
        </div>
        <div class="col-6" style="height: 50px">
          <p style="margin-top: 0; margin-bottom: -10px">Avg. Speed</p>
          <p style="font-weight: 1000; color: #1e1e1e">${avgSpeed} knot</p>
        </div>
        <div class="col-6" style="height: 50px">
          <p style="margin-top: 0; margin-bottom: -10px">Current AE</p>
          <p style="font-weight: 1000; color: #1e1e1e">AE ${currentAE}</p>
        </div>
      `;
    } else if (this.currentDotTrailPopupPage === 2) {
      // Build RPM row dynamically based on available types
      if (rpmValues.length > 0) {
        rpmValues.forEach((rpmItem) => {
          content += /* html */`
            <div class="col-6" style="height: 50px">
              <p style="margin-top: 0; margin-bottom: -10px; color: #1e1e1e">${rpmItem.displayLabel} RPM</p>
              <p style="font-weight: 1000; color: #1e1e1e">${rpmItem.value}</p>
            </div>
          `;
        });
      } else {
        // Fallback if no RPM data
        content += /* html */`
          <div class="col-12" style="height: 50px">
            <p style="margin-top: 0; margin-bottom: -10px">No RPM data available</p>
          </div>
        `;
      }
    }

    content += /* html */`
    </div><div class="row"><div class="col-12 d-flex justify-content-between">
        <button class="btn btn-sm btn-outline-mantraz" id="previous-popup-button-${ship.massId}-${data.timestamp}" ${this.currentDotTrailPopupPage === 1 ? 'disabled' : ''}>Previous</button>
        <button class="btn btn-sm btn-outline-mantraz" id="next-popup-button-${ship.massId}-${data.timestamp}" ${this.currentDotTrailPopupPage === 2 ? 'disabled' : ''}>Next</button>
    </div></div>`;
    return content;
  }

  setupDotTrailPaginationButtons(marker, ship, data) {
    this.setupButtonEvent(`previous-popup-button-${ship.massId}-${data.timestamp}`, () => {
      if (this.currentDotTrailPopupPage > 1) {
        this.currentDotTrailPopupPage--;
        marker.setPopupContent(this.createDotTrailPopupContent(ship, data));
        this.setupDotTrailPaginationButtons(marker, ship, data);
      }
    });
    this.setupButtonEvent(`next-popup-button-${ship.massId}-${data.timestamp}`, () => {
      if (this.currentDotTrailPopupPage < 2) {
        this.currentDotTrailPopupPage++;
        marker.setPopupContent(this.createDotTrailPopupContent(ship, data));
        this.setupDotTrailPaginationButtons(marker, ship, data);
      }
    });
  }

  // --- Opsi Helper ---

  getPolylineMeasureOptions() {
    return {
      position: 'topleft',
      unit: 'kilometres',
      useSubunits: true,
      clearMeasurementsOnStop: false,
      showBearings: true,
      bearingTextIn: 'In',
      bearingTextOut: 'Out',
      tooltipTextFinish: 'Click to <b>finish line</b><br>',
      tooltipTextDelete: 'Press SHIFT-key and click to <b>delete point</b>',
      tooltipTextMove: 'Click and drag to <b>move point</b><br>',
      tooltipTextResume: '<br>Press CTRL-key and click to <b>resume line</b>',
      tooltipTextAdd: 'Press CTRL-key and click to <b>add point</b>',
      measureControlTitleOn: 'Turn on PolylineMeasure',
      measureControlTitleOff: 'Turn off PolylineMeasure',
      measureControlLabel: '&#8614;',
      measureControlClasses: [],
      showClearControl: true,
      clearControlTitle: 'Clear Measurements',
      clearControlLabel: '&times',
      clearControlClasses: [],
      showUnitControl: true,
      unitControlUnits: [
        'kilometres',
        'landmiles',
        'nauticalmiles',
      ],
      unitControlTitle: {
        text: 'Change Units',
        kilometres: 'kilometres',
        landmiles: 'land miles',
        nauticalmiles: 'nautical miles',
      },
      unitControlLabel: {
        metres: 'm',
        kilometres: 'km',
        feet: 'ft',
        landmiles: 'mi',
        nauticalmiles: 'nm',
      },
      unitControlClasses: [],
      tempLine: {
        color: '#00f',
        weight: 2,
      },
      fixedLine: {
        color: '#006',
        weight: 2,
      },
      arrow: {
        color: '#000',
      },
      startCircle: {
        color: '#000',
        weight: 1,
        fillColor: '#0f0',
        fillOpacity: 1,
        radius: 3,
      },
      intermedCircle: {
        color: '#000',
        weight: 1,
        fillColor: '#ff0',
        fillOpacity: 1,
        radius: 3,
      },
      currentCircle: {
        color: '#000',
        weight: 1,
        fillColor: '#f0f',
        fillOpacity: 1,
        radius: 6,
      },
      endCircle: {
        color: '#000',
        weight: 1,
        fillColor: '#f00',
        fillOpacity: 1,
        radius: 3,
      },
    };
  }

  panToShip(ship) {
    if (!this.map || !ship.lastLatLng) return;

    this.map.setView(ship.lastLatLng, 15, {
      animate: true,
      pan: {
        duration: 1,
      },
    });
  }

  // --- Landmark ---

  addMapSettingsControl() {
    if (!this.map) return;
    const MapSettingsControl = L.Control.extend({
      onAdd: () => {
        const container = L.DomUtil.create('div', 'leaflet-map-settings');
        const toggle = L.DomUtil.create('button', 'map-settings-toggle', container);
        toggle.type = 'button';
        toggle.innerHTML = '<i class="ri-settings-3-line"></i>';

        const panel = L.DomUtil.create('div', 'map-settings-panel hidden', container);
        panel.innerHTML = `
          <div class="map-settings-item map-settings-header">Base Map</div>
          <label class="map-settings-option">
            <input type="radio" name="map-base-layer" value="satellite" />
            <span>Satellite</span>
          </label>
          <label class="map-settings-option">
            <input type="radio" name="map-base-layer" value="vectorColor" />
            <span>Vector color</span>
          </label>
          <label class="map-settings-option">
            <input type="radio" name="map-base-layer" value="vectorWhite" />
            <span>Vector white</span>
          </label>
          <div class="map-settings-separator"></div>
          <label class="map-settings-switch">
            <input type="checkbox" id="map-toggle-landmarks" />
            <span>Landmarks</span>
          </label>
        `;

        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        toggle.onclick = () => {
          panel.classList.toggle('hidden');
        };

        const baseInputs = panel.querySelectorAll('input[name="map-base-layer"]');
        baseInputs.forEach((input) => {
          input.addEventListener('change', (event) => {
            this.setBaseLayer(event.target.value);
          });
        });

        const landmarksToggle = panel.querySelector('#map-toggle-landmarks');
        landmarksToggle.addEventListener('change', (event) => {
          this.toggleLandmarks(event.target.checked);
        });

        this.mapSettingsPanel = panel;
        this.syncMapSettingsUI();

        return container;
      },
    });
    this.map.addControl(new MapSettingsControl({ position: 'topleft' }));
  }

  syncMapSettingsUI() {
    if (!this.mapSettingsPanel) return;
    const activeBaseInput = this.mapSettingsPanel.querySelector(`input[name="map-base-layer"][value="${this.activeBaseLayerKey}"]`);
    if (activeBaseInput) {
      activeBaseInput.checked = true;
    }
    const landmarksToggle = this.mapSettingsPanel.querySelector('#map-toggle-landmarks');
    if (landmarksToggle) {
      landmarksToggle.checked = this.landmarksVisible;
    }
  }

  setBaseLayer(layerKey) {
    if (!this.map || !this.baseLayers[layerKey]) return;
    if (this.activeBaseLayer) {
      this.map.removeLayer(this.activeBaseLayer);
    }
    this.activeBaseLayer = this.baseLayers[layerKey];
    this.activeBaseLayerKey = layerKey;
    this.activeBaseLayer.addTo(this.map);
    localStorage.setItem('activeBaseLayer', layerKey);
    this.syncMapSettingsUI();
  }

  toggleLandmarks(forceState) {
    this.landmarksVisible = typeof forceState === 'boolean' ? forceState : !this.landmarksVisible;
    if (!this.landmarksVisible) {
      if (this.landmarksLayer) {
        this.landmarksLayer.clearLayers();
      }
      this.syncMapSettingsUI();
      return;
    }
    this.lastLandmarkBoundsKey = null;
    this.lastLandmarkBounds = null;
    const storedLandmarks = this.vm?.$store?.getters['landmark/landmarks'];
    const storedBounds = this.vm?.$store?.getters['landmark/bounds'];
    if (Array.isArray(storedLandmarks) && storedLandmarks.length) {
      this.landmarks = storedLandmarks;
      this.renderLandmarks();
    }
    if (storedBounds) {
      this.lastLandmarkBounds = L.latLngBounds(
        [storedBounds.minLatitude, storedBounds.minLongitude],
        [storedBounds.maxLatitude, storedBounds.maxLongitude],
      );
    }
    this.fetchLandmarksInView();
    this.syncMapSettingsUI();
  }

  handleLandmarkViewportChange() {
    if (!this.landmarksVisible) return;
    this.scheduleLandmarkFetch();
  }

  scheduleLandmarkFetch() {
    if (this.landmarkFetchTimeout) {
      clearTimeout(this.landmarkFetchTimeout);
    }
    this.landmarkFetchTimeout = setTimeout(() => {
      this.fetchLandmarksInView();
    }, 300);
  }

  async fetchLandmarksInView() {
    if (!this.map || !this.landmarksVisible) return;
    const bounds = this.map.getBounds();
    if (!bounds) return;
    const paddedBounds = bounds.pad(0.25);
    if (this.lastLandmarkBounds && this.lastLandmarkBounds.contains(paddedBounds)) {
      this.renderLandmarks();
      return;
    }
    const sw = paddedBounds.getSouthWest();
    const ne = paddedBounds.getNorthEast();
    const boundsKey = `${sw.lat.toFixed(3)}:${sw.lng.toFixed(3)}:${ne.lat.toFixed(3)}:${ne.lng.toFixed(3)}:${this.map.getZoom()}`;
    if (boundsKey === this.lastLandmarkBoundsKey) {
      this.renderLandmarks();
      return;
    }
    this.lastLandmarkBoundsKey = boundsKey;
    this.lastLandmarkBounds = paddedBounds;

    try {
      const response = await LandmarkSvc.landmarks.area({
        minLatitude: sw.lat,
        maxLatitude: ne.lat,
        minLongitude: sw.lng,
        maxLongitude: ne.lng,
      });
      const data = Array.isArray(response?.data?.data) ? response.data.data : [];
      this.landmarks = data;
      if (this.vm?.$store) {
        this.vm.$store.dispatch('landmark/setLandmarks', {
          landmarks: data,
          bounds: {
            minLatitude: sw.lat,
            maxLatitude: ne.lat,
            minLongitude: sw.lng,
            maxLongitude: ne.lng,
          },
        });
      }
      this.renderLandmarks();
    } catch (error) {
      console.warn('Failed to fetch landmarks area:', error);
    }
  }

  renderLandmarks() {
    if (!this.map || !this.landmarksVisible) return;
    if (!this.landmarksLayer) {
      this.landmarksLayer = L.layerGroup().addTo(this.map);
    }
    if (!this.landmarkIcon) {
      this.landmarkIcon = L.icon({
        iconUrl: '/marker/pinpoint.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });
    }
    this.landmarksLayer.clearLayers();
    if (!this.landmarks.length) return;

    const zoom = this.map.getZoom();
    const useCluster = zoom < this.clusterZoomThreshold;
    if (!useCluster) {
      this.landmarks.forEach((landmark) => this.addLandmarkMarker(landmark));
      return;
    }

    const cellSize = this.getClusterCellSize(zoom);
    const clusters = new Map();
    this.landmarks.forEach((landmark) => {
      const lat = parseFloat(landmark.lndmLatitude);
      const lng = parseFloat(landmark.lndmLongitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) return;
      const cellLat = Math.floor(lat / cellSize);
      const cellLng = Math.floor(lng / cellSize);
      const key = `${cellLat}:${cellLng}`;
      if (!clusters.has(key)) {
        clusters.set(key, {
          count: 0,
          sumLat: 0,
          sumLng: 0,
          landmarks: [],
        });
      }
      const cluster = clusters.get(key);
      cluster.count += 1;
      cluster.sumLat += lat;
      cluster.sumLng += lng;
      cluster.landmarks.push(landmark);
    });

    clusters.forEach((cluster) => {
      if (cluster.count === 1) {
        this.addLandmarkMarker(cluster.landmarks[0]);
        return;
      }
      const avgLat = cluster.sumLat / cluster.count;
      const avgLng = cluster.sumLng / cluster.count;
      const marker = L.marker([avgLat, avgLng], {
        icon: this.createClusterIcon(cluster.count),
      });
      marker.on('click', () => {
        const nextZoom = Math.min(this.map.getZoom() + 2, this.map.getMaxZoom());
        this.map.setView([avgLat, avgLng], nextZoom);
      });
      marker.addTo(this.landmarksLayer);
    });
  }

  addLandmarkMarker(landmark) {
    const lat = parseFloat(landmark.lndmLatitude);
    const lng = parseFloat(landmark.lndmLongitude);
    if (Number.isNaN(lat) || Number.isNaN(lng)) return;
    const marker = L.marker([lat, lng], {
      icon: this.landmarkIcon,
      landmarkId: landmark.lndmId,
    });
    const name = landmark.lndmName ? this.escapeHtml(landmark.lndmName) : '-';
    const type = landmark.lndmType ? this.escapeHtml(String(landmark.lndmType).toUpperCase()) : '-';
    marker.bindPopup(`<strong>${name}</strong><br>Type: ${type}`);
    marker.addTo(this.landmarksLayer);
  }

  createClusterIcon(count) {
    return L.divIcon({
      className: 'landmark-cluster-wrapper',
      html: `<div class="landmark-cluster">${count}</div>`,
      iconSize: [36, 36],
      iconAnchor: [18, 18],
    });
  }

  getClusterCellSize(zoom) {
    if (zoom <= 3) return 6;
    if (zoom <= 5) return 3;
    if (zoom <= 7) return 1.5;
    return 1;
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}

export default MapService;
